import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { authActions } from '../../store/auth/auth.actions';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  standalone: true,
  imports: [NgIf, MatProgressSpinnerModule],
})
export class WelcomeComponent {
  loginInProgress = false;

  constructor(private route: ActivatedRoute, store: Store) {
    this.route.queryParams.subscribe((params) => {
      if (params['token']) {
        console.log(params['token'])
        localStorage.clear();
        this.loginInProgress = true;
        const token = <string>params['token'];
        // const refreshToken = <string>params.refreshToken;
        store.dispatch(authActions.createNewToken({ token: token }));
        // store.dispatch(
        //   AuthActions.loginSuccess({
        //     token: token,
        //     refreshToken: refreshToken,
        //     redirect: true,
        //   })
        // );
        //
        // store.dispatch(AuthActions.refreshingToken({token, refreshToken}));
      } else {
        this.redirectToSSO(1);
      }
    });
  }

  redirectToSSO(index: number): void {
    this.loginInProgress = true;
    if (index == 1) {
      //this.router.navigateByUrl(`${environment.url_sso}/?redirect_url=${window.location.href}`);
      window.location.href = `${environment.url_sso}/?redirect_url=${window.location.href}`;
    } else if (index == 0) {
      window.location.href = `${environment.url_sso_register}/?redirect_url=${window.location.href}`;
      // this.router.navigateByUrl(`${environment.url_sso_register}/?redirect_url=${window.location.href}`);
    } else if (index == 2) {
      window.location.href = `${environment.url_sso_recovery}/?redirect_url=${window.location.href}`;
      // this.router.navigateByUrl(`${environment.url_sso_recovery}/?redirect_url=${window.location.href}`);
    }
  }
}
